import React, { useState } from 'react';
import Slider from 'react-slick';
import FsLightbox from 'fslightbox-react';

import King1 from '../../../assets/img/bg/D1.jpg';
import King2 from '../../../assets/img/bg/D2.jpg';
import King3 from '../../../assets/img/bg/D3.jpg';
import King4 from '../../../assets/img/bg/D4.jpg';
import King5 from '../../../assets/img/bg/D5.jpg';
import King6 from '../../../assets/img/bg/D6.jpg';
import King7 from '../../../assets/img/bg/D7.jpg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function First() {
  const [toggler, setToggler] = useState(false);
  const [activeSlide, setActiveSlide] = useState(1); // FsLightbox usa índice basado en 1

  const images = [King1, King2, King3, King4, King5, King6, King7];

  const openLightbox = (index) => {
    setActiveSlide(index + 1);
    setToggler(!toggler);
  };

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 400,
    cssEase: "ease-in-out",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <>
      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-40">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-detail">
                
                {/* SLIDER */}
                <Slider {...sliderSettings} className="custom-slider">
                  {images.map((img, index) => (
                    <div key={index} className="slide-wrapper">
                      <figure className="image" onClick={() => openLightbox(index)}>
                        <img
                          src={img}
                          alt={`Habitación ${index + 1}`}
                          className="slider-image"
                        />
                      </figure>
                    </div>
                  ))}
                </Slider>

                {/* FSLIGHTBOX como en Rooms */}
                <FsLightbox
                  toggler={toggler}
                  sources={images}
                  slide={activeSlide}
                />

                {/* CONTENIDO */}
                <div className="content-box mt-50">
                  <div className="row align-items-center mb-50">
                    <div className="col-lg-6 col-md-6">
                      <div className="price">
                        <h2>Habitación con Camas Dobles</h2>
                      </div>
                    </div>
                  </div>

                  <p>
                    Disfruta de una estancia cómoda y placentera en nuestra espaciosa habitación con dos camas dobles, pensada para familias o grupos pequeños que desean compartir momentos sin sacrificar privacidad ni comodidad. Con un diseño acogedor y funcional, esta habitación es perfecta para descansar después de un día lleno de actividades. Cada detalle ha sido cuidadosamente seleccionado para garantizar una experiencia relajante y práctica, creando el entorno ideal para convivir, descansar y disfrutar juntos.
                  </p>

                  <h3>Características de la habitación</h3>
                  <ul className="room-features d-flex align-items-center flex-wrap">
                    <li><i className="fal fa-tv-retro"></i> TV</li>
                    <li><i className="fal fa-wifi"></i> Free Wifi</li>
                    <li><i className="fal fa-phone-rotary"></i> Teléfono</li>
                    <li><i className="fal fa-user"></i> Adultos: 2-4</li>
                    <li><i className="fal fa-bed"></i> Dos camas matrimoniales</li>
                    <li><i className="fal fa-car"></i> Estacionamiento</li>
                    <li><i className="fal fa-mug-hot"></i> Café</li>
                  </ul>

                  <div className="mb-50">
                    <a
                      href="https://us2.cloudbeds.com/en/reservation/2C4nnm?currency=mxn"
                      className="btn ss-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Reserva
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ESTILOS opcionales */}
      <style jsx>{`
        .custom-slider .slick-slide {
          padding: 0 10px;
        }

        .slide-wrapper {
          cursor: pointer;
        }

        .slider-image {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 4px;
          transition: transform 0.2s ease;
        }

        .slider-image:hover {
          transform: scale(1.01);
        }

        .slick-prev, .slick-next {
          z-index: 5;
        }

        .slick-prev { left: -13px; }
        .slick-next { right: -13px; }

        .slick-prev:before,
        .slick-next:before {
          font-size: 25px;
          color: #9e7b4f;
        }
      `}</style>
    </>
  );
}

export default First;
